import script from "./BalTextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTextInput.vue?vue&type=script&setup=true&lang=ts"

import "./BalTextInput.vue?vue&type=style&index=0&id=afd61a92&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afd61a92"]])

export default __exports__